import { render, staticRenderFns } from "./MarkingsList.vue?vue&type=template&id=064425c1&scoped=true&"
import script from "./MarkingsList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MarkingsList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MarkingsList.vue?vue&type=style&index=0&id=064425c1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064425c1",
  null
  
)

export default component.exports